<template>
  <div class="faq-data">
    <div v-for="(item,index) in faq.body" class="card-inner-wrapper">
      <faq-item :item="item"></faq-item>
      <div class="inner-block-actions">
        <v-btn
          @click="deleteLang(index)"
          fab small color=""
          class=""
        ><v-icon  color="red">delete_outline</v-icon></v-btn>
      </div>
    </div>
    <v-btn
      large round flat block
      class="primary--text"
      @click="addNewLang"
    >
      <v-icon>add_circle_outline</v-icon>
      Add New Language
    </v-btn>
  </div>
</template>

<script>
  import faqItem from './faqItem'
  import common from "../../../../utils/common";
  export default {
    name: "faqData",
    components: {
      faqItem
    },
    props: {
      faq: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
    methods: {
      addNewLang () {
        this.faq.body.push({
          question: '',
          answer: '',
          locale: ''
        })
      },
      deleteLang (index) {
        this.faq.body.splice(index,1)
      },
      updateFaq () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.put(`/bot_objects/faqs/${this.faq.id}`, this.faq)
          .then(response=> {
            this.$store.dispatch('setSavingStatus', false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', false)
            }
          })
      },
    },
    watch: {
      faq: {
        handler(val ){
          this.updateFaq()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>

</style>
